import { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'
import { ListCell } from '@src/components/table-list/cells'
import { Subtitle1 } from '@src/elements/typography/typography'
import Activity from '@src/data/activity'
import { MemberActivityType } from '@src/routes/members/member-activities'

@Component({
  computed: {
    allActivities () {
      return this.$store.state.activities || []
    }
  }
})
export class ActivityNameCell extends ListCell {

  item: string

  private allActivities: Activity[]

  render (h: CreateElement) {
    const title = this.getTitle()

    return <div class='cell activity-name-cell'>
      <img src={this.getActivityImage(this.item[this.name])} />
      <Subtitle1>{title}</Subtitle1>
    </div>
  }

  private getTitle () {
    const key = this.item[this.name]
    if (key === MemberActivityType.CLASS) {
      return this.item['name']
    }
    if (key === 'pixHomeWorkout') {
      // Prefer provided workout name; fallback to the same translation used in filters
      return this.item['name'] || this.$t('PAGE.MEMBERS.ACTIVITIES.TYPES.PIX_HOME_WORKOUT')
    }
    if (key === MemberActivityType.PIX_WORKOUT) {
      return this.$t('PAGE.MEMBERS.ACTIVITIES.TYPES.STATION_WORKOUT')
    }
    return this.$t(`ACTIVITIES.${key.toUpperCase()}`)
  }

  private getActivityImage (key: string) {
    const activity = this.allActivities.filter(activity => activity.key === key)[0]
    if (activity) {
      return activity.image2x
    }
  }
}
